import { Thumb } from "./thumb.model";

export class Archive {
    id: number;
    name: string;
    description: string;
    current: string;
    thumbs: Array<Thumb>;

    constructor() {
        this.thumbs = new Array<Thumb>();
    }
}


// WEBPACK FOOTER //
// C:/pgutev/work/WEBCAM/src/app/models/archive.model.ts